import Keycloak from "keycloak-js";
//#region src/modules/core/data/keycloak.ts
var keycloakInstance = null;
var STORAGE_KEYS = {
	token: "kc_token",
	refreshToken: "kc_refreshToken",
	idToken: "kc_idToken"
};
var loadSession = () => ({
	token: sessionStorage.getItem(STORAGE_KEYS.token) ?? void 0,
	refreshToken: sessionStorage.getItem(STORAGE_KEYS.refreshToken) ?? void 0,
	idToken: sessionStorage.getItem(STORAGE_KEYS.idToken) ?? void 0
});
var saveSession = (keycloak) => {
	if (keycloak?.token) sessionStorage.setItem(STORAGE_KEYS.token, keycloak.token);
	if (keycloak?.refreshToken) sessionStorage.setItem(STORAGE_KEYS.refreshToken, keycloak.refreshToken);
	if (keycloak?.idToken) sessionStorage.setItem(STORAGE_KEYS.idToken, keycloak.idToken);
};
var clearSession = () => {
	Object.values(STORAGE_KEYS).forEach((key) => sessionStorage.removeItem(key));
};
var initKeycloak = async (keycloakConfig) => {
	if (!keycloakInstance) {
		keycloakInstance = new Keycloak(keycloakConfig);
		keycloakInstance.onAuthLogout = clearSession;
		keycloakInstance.onAuthRefreshError = clearSession;
		keycloakInstance.onAuthRefreshSuccess = () => saveSession(keycloakInstance);
		await keycloakInstance.init({
			checkLoginIframe: false,
			onLoad: "check-sso",
			...loadSession()
		});
		saveSession(keycloakInstance);
	}
	return keycloakInstance;
};
var getKeycloak = () => {
	if (!keycloakInstance) throw new Error("Keycloak not initialized");
	return keycloakInstance;
};
//#endregion
export { getKeycloak, initKeycloak };
